import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { readMobileTheme } from './hooks/useMobileTheme'

// 初始化手機主題（在 React 掛載前設定，避免閃爍）
document.documentElement.setAttribute('data-mobile-theme', readMobileTheme());

// 靜默處理 Supabase auth token 自動刷新的網路錯誤
// 這類 "Failed to fetch" 屬於背景機制，不影響功能
window.addEventListener('unhandledrejection', (event) => {
  const msg = event?.reason?.message || '';
  if (
    msg.includes('Failed to fetch') ||
    msg.includes('NetworkError') ||
    msg.includes('Load failed')
  ) {
    event.preventDefault();
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
